import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import Pluralize from 'pluralize';
import { FORMAT_WEEKDAY_DATE_MINI } from 'utils/helpers/datetime';
import { getDateObjectFromReservation } from 'utils/helpers/reservations';
import { getNextUpcomingReservation } from 'redux/selectors/current_booking';
import View from './view';

const Accommodation = () => {
  const upcomingReservation = useSelector(getNextUpcomingReservation);
  const name = upcomingReservation.selection_name;
  const reservationDate = getDateObjectFromReservation(upcomingReservation);
  const checkInDate = format(reservationDate, FORMAT_WEEKDAY_DATE_MINI);
  const duration = `${upcomingReservation.duration} ${Pluralize(
    'night',
    upcomingReservation.duration
  )}`;
  const date = `${checkInDate} - ${duration}`;

  return <View name={name} date={date} />;
};

export default Accommodation;
